import { createContext, useContext, useState } from 'react'

import { useDisclosure } from '@mantine/hooks'

export interface EmailModalOptions {
  applicantId?: string
  defaultTo?: string
  defaultSubject?: string
  defaultBody?: string
  onSuccess?: () => void
}

const EmailModalContext = createContext(null)

const EmailModalContextProvider = ({ children }) => {
  const [opened, { open, close }] = useDisclosure(false)
  const [applicantId, setApplicantId] = useState<string | null>(null)
  const [defaultTo, setDefaultTo] = useState('')
  const [defaultSubject, setDefaultSubject] = useState('')
  const [defaultBody, setDefaultBody] = useState('')
  const [onSuccess, setOnSuccess] = useState<(() => void) | null>(null)

  const handleOpen = ({
    applicantId = null,
    defaultTo = '',
    defaultSubject = '',
    defaultBody = '',
    onSuccess,
  }: EmailModalOptions = {}) => {
    setApplicantId(applicantId)
    setDefaultTo(defaultTo)
    setDefaultSubject(defaultSubject)
    setDefaultBody(defaultBody)
    setOnSuccess(() => onSuccess)
    open()
  }

  const handleClose = () => {
    setApplicantId(null)
    setDefaultTo('')
    setDefaultSubject('')
    setDefaultBody('')
    setOnSuccess(null)
    close()
  }

  return (
    <EmailModalContext.Provider
      value={{
        opened,
        handleOpen,
        handleClose,
        applicantId,
        defaultTo,
        defaultSubject,
        defaultBody,
        onSuccess,
      }}
    >
      {children}
    </EmailModalContext.Provider>
  )
}

export function useEmailModalContext() {
  return useContext(EmailModalContext)
}

export { EmailModalContext, EmailModalContextProvider }
